import * as $ from 'jquery';
import bootSetCookie from "@/js/cookies/SetCookies";

export const SetVisitedProducts = () =>{
	/**
	 * Recent viewed products on cookies
	 */
	if( $('.single-product').length ){
		const prodId = $('.product-identifier-js').data('id');
		bootSetCookie('recentproduct_'+prodId,'viewed',3);
	}
}
